import React from "react";
import { FileUploadConfig } from "./types";
import { formatFileSize } from "./utils";

interface FileUploadInfoProps {
  config: FileUploadConfig;
}

export const FileUploadInfo: React.FC<FileUploadInfoProps> = ({ config }) => {
  return (
    <div
      style={{
        marginBottom: "20px",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderRadius: "6px",
        fontSize: "14px",
        color: "#666"
      }}
    >
      <div>
        <strong>파일 업로드 제한:</strong>
      </div>
      <div>• 개별 파일 최대 크기: {formatFileSize(config.maxFileSize)}</div>
      <div>• 전체 파일 최대 크기: {formatFileSize(config.maxTotalSize)}</div>
    </div>
  );
};
